import React from "react";
import "./Loader.css";

// Compact animated ring, also used as the global antd <Spin>/<Table> indicator.
export const LoaderSpinner = ({ size = 48 }) => (
  <span
    className="ax-spinner"
    style={{ width: size, height: size }}
    role="status"
    aria-label="Loading"
  >
    <span className="ax-spinner__ring" />
    <span className="ax-spinner__ring ax-spinner__ring--inner" />
    <span className="ax-spinner__core" />
  </span>
);

/**
 * App-wide loader.
 * - default: fullscreen blurred overlay (route transitions, page-level API calls)
 * - inline: centered inside its parent container (sections, cards)
 */
const Loader = ({ inline = false, text = "Loading", size }) => (
  <div className={inline ? "ax-loader ax-loader--inline" : "ax-loader"} aria-busy="true">
    <div className="ax-loader__content">
      <LoaderSpinner size={size || (inline ? 40 : 64)} />
      {text && (
        <div className="ax-loader__text">
          {text}
          <span className="ax-loader__dots">
            <i>.</i>
            <i>.</i>
            <i>.</i>
          </span>
        </div>
      )}
    </div>
  </div>
);

export default Loader;
